import {RECOMMENDED_FONTS} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {FontItem} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';

export function AllFonts({onClick, selectedFont}) {
  return window.fonts
    .filter((font) => !RECOMMENDED_FONTS.some((rf) => rf.name === font.name))
    .map((option, index) => (
      <FontItem
        font={option}
        key={`${option.name}_${index}`}
        onClick={onClick}
        selected={option.name === selectedFont?.name}
      />
    ));
}
